import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import one from './BannerSlider/p1.png'
import two from './BannerSlider/p2.png'
import base from './base_url'

function BannerSlider(props) {
  return (
    <Carousel>

{


props.bannerList.map((e)=>(
    <Carousel.Item>
      <img
      className="d-block w-100"
      src={base.base+"/"+e.banner_img}
      alt="Second slide"
      style={{width:'100%'}}
    />
       
      </Carousel.Item>
))


}
    
  
    </Carousel>
  );
}

export default BannerSlider;
